import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  alignItems: 'center',
  textAlign: 'center',
  pt: 3,
};
